import React, {  useEffect, useState } from 'react'; 
import Image from 'next/image';
import { useRouter } from 'next/router';
import Head from "next/head";
import { getMetadata } from "@/component/shared/getMetaData";
import enIN from '@/locales/about/enIN';
import esMX from '@/locales/about/esMX';
import enUS from '@/locales/about/enUS';
import { ENDPOINTS } from '@/config/endpoints';

const AboutUs = () =>{
    const router = useRouter();
    const { locale } = router;
    const t = (locale === 'es-mx' && esMX) || (locale === 'en-us' && enUS) || (locale === 'en-in' && enIN);
    const metadata = getMetadata(t);
    const [leadershipData, setLeadershipData] = useState([]);

      useEffect(() => {
        const fetchLeadershipData = async () => {
            try {
                const apiUrl = locale === "en-us"? ENDPOINTS.LEADERSHIP_API("CREDLIX_USA", "credlix-usa-leadership")
                               : locale === "es-mx" ? ENDPOINTS.LEADERSHIP_API("CREDLIX_MEXICO", "credlix-mexico-leadership")
                               : ENDPOINTS.LEADERSHIP_API("CREDLIX", "credlix-india-leadership");
                               
                const response = await fetch(apiUrl);
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                const leaders = data.data.leaders.map((leader) => ({
                    name: leader.name,
                    designation: leader.designation,
                    image: leader.images.color,
                    key: leader.key,
                  }));            
                setLeadershipData(leaders);
            } catch (error) {
                console.error('Error fetching leadership data:', error);
            }
        };
        fetchLeadershipData();
      }, [locale]);
      
    return(
        <main>

            <Head>
              <title>{metadata.title}</title>
              <meta name="description" content={metadata.description} />
              <meta name="keywords" content={metadata.keywords} />
              <link rel="icon" href={metadata.icon} />
              <meta property="og:title" content={metadata.openGraph.title} />
              <meta property="og:description" content={metadata.openGraph.description} />
              <meta property="og:image" content={metadata.openGraph.images} />
              <meta property="og:url" content={metadata.openGraph.url} />
              <link rel="canonical" href={metadata.alternates.canonical} />
              <link rel="preload" as="image" href={t.banner.bannerImage.src}/>
            </Head>
            
                <section className='bg-gradient-to-b from-white to-[#E0EFFD] sm:h-auto h-[75vh] md:h-[60vh] sm:py-20 min-h-[650px] md:min-h-[500px] sm:min-h-[667px] sm:pt-[140px]  sm:pb-0'>
                        <div className='container h-full  lg:px-3 xm:px-2 px-3'>
                            <div className='flex sm:flex-col items-center h-full space-x-10 sm:space-x-0'>
                                <div className='w-[45%] md:w-1/2 sm:w-full xm:pt-[10%] lg:pt-[10%]' >
                                    <div className='relative'>
                                        <h1 className='text-heading1 text-brand font-[400] mb-3'>
                                        <span className='border-b-2 border-[#E9B642]'>{t.banner.bannerHeadingUnderlineText}</span> {t.banner.bannerHeadingText}</h1>
                                        <p className='text-lg text-[#2c2c2c]'>{t.banner.bannerParaText}</p>
                                    </div>
                                </div>
                                <div className='w-[55%] md:w-1/2 sm:w-[100%] sm:mr-0' >
                                    <div>
                                     <Image className='ml-auto flex items-center justify-center w-[75%] sm:w-full pt-[80px] sm:pt-[0px] lg:mb-[-200px] sm:mt-6' priority={true} fetchPriority='high' src={t.banner.bannerImage} alt={t.banner.bannerHeadingUnderlineText + t.banner.bannerHeadingText} width={540} height={528}/>
                                    </div>
                                    
                                    
                                </div>
                            </div>
                        </div>
            </section>
            <section className='bg-white sm:pt-20 sm:pb-0 lg:mt-[130px]'>
                <div className='container  lg:px-3 px-3 xm:px-2'>
                    
                    <div className='flex flex-wrap sm:flex-col items-center'>
                        <div className='w-1/2 sm:w-full' >
                            <div>
                                <h2 className='text-xxxl text-secondary font-medium'>
                                     {t.section1Head.WWD} <br/> {t.section1Head.supplyChain}
                                </h2>
                            </div>
                        </div>
                       
                    </div>
                    {t.section.map((item,i)=>(
                        <div key={i} className={`odd:flex-row-reverse flex flex-wrap sm:flex-col items-center pt-4 pb-20`}>
                            <div className='w-1/2 sm:w-full' >
                                <div>
                                    <p className='text-lg text-secondary' dangerouslySetInnerHTML={{__html: item.para1}}/> 
                                    <p className='text-lg text-secondary mt-3' dangerouslySetInnerHTML={{__html: item.para2}}/>
                                </div>
                            </div>
                            <div className='w-1/2 sm:w-full' >
                                <div className='sm:pt-5'>
                                    <Image width={400} className='w-[400px] h-auto mx-auto' src={item.image} alt={'item'+i}/>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </section>
            <section className='bg-[#F1F0F6] py-20'>
                <div className='container px-3 xm:px-2  lg:px-3'>
                    <div className='text-center'>
                        <h2 className='text-xl text-secondary font-medium mb-3'>{t.meetTeam.heading}</h2>
                        <p className='text-base text-secondary mb-16 max-w-[1100px] mx-auto'>{t.meetTeam.para}</p>
                    </div>
                    <div className='mx-auto max-w-[65%] sm:max-w-full md:max-w-full md'>
                    <div className='flex flex-wrap mt-12 -mx-xsp sm:flex-col justify-start'>
                        {leadershipData.map((item)=>(
                            <div key={item.key} className='p-2 w-1/3 md:w-1/2 sm:w-full'>
                            <div className={`bg-white shadow-icon-btn-shadow rounded-lg p-2 ${
                              locale === 'es-mx' ? 'h-68 min-h-[270px]' : 'h-64'}`}>
                               {item.image &&  <Image loading='lazy' className='m-auto w-[150px] h-[149px]' src={item.image} alt="Rahul Garg" width={150} height={149}/>}
                               {item.name && <h3 className='text-lg text-secondary font-bold text-center mt-2'>{item.name}</h3>}
                               {item.designation && <p className='text-sm text-secondary text-center'>{item.designation}</p>}
                            </div>
                        </div>
                        ))}
                    </div>
                    </div>
                </div>
            </section>
        </main>
    );
    };
    
export default AboutUs;